module.exports = __webpack_public_path__ + "static/rentcap2-88a6f9cbf838c69c1ad0c85d195b7a0d.svg";